<template>
    <div>
        <div v-if="authUserPermission['end-user-search-material-view']">
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>
                </div>
            </base-header>
            <div class="container-fluid mt--7">
                 <div class="card" v-if="isSearched">
                    <div class="card-header mt--4">
                        <div class="row">
                            <div class="col">
                                <h3 class="mb-0">Search Result</h3>
                            </div>
                             <div>
                                <el-select v-model="params.per_page" :placeholder="tt('Show data')" @change="chanePerPage">
                                    <el-option label="Tampilkan 25 data" :value="25"></el-option>
                                    <el-option label="Tampilkan 50 data" :value="50"></el-option>
                                    <el-option label="Tampilkan 100 data" :value="100"></el-option>
                                    <el-option label="Tampilkan 150 data" :value="150"></el-option>
                                    <el-option label="Tampilkan 200 data" :value="200"></el-option>
                                </el-select>
                            </div>
                            <div class="text-right mr-3">
                                 <el-button-group class="ml-2">
                                    <el-button type="danger" @click="backToForm">Back</el-button>
                                    <el-button @click="exportExcel" type="primary">Excel</el-button>
                                </el-button-group>
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-table height="500px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table" v-if="!loadTable">
                            <el-table-column :label="tt('plant')" :prop="tt('plant')" min-width="200px" sortable>
                                 <template slot="header" slot-scope="scope">
                                    <div class="row">
                                        <div class="col-12" style="text-align:center;">
                                            {{ tt('plant') }}
                                        </div>
                                        <div class="col-12">
                                            <el-input size="mini" class="mb-2" v-model="params.plant" @change="filter"></el-input>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot="{row}">
                                    {{row.plant_code }}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('mcr_number')" :prop="tt('mcr_number')" min-width="250px" sortable>
                                 <template slot="header" slot-scope="scope">
                                    <div class="row">
                                        <div class="col-12" style="text-align:center;">
                                            {{ tt('mcr_number') }}
                                        </div>
                                        <div class="col-12">
                                            <el-input size="mini" class="mb-2" v-model="params.mcr_number" @change="filter"></el-input>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot="{row}">
                                    <router-link :to="'/material/mcr-form/'+row.form_type+'/'+row.mcr_code+'/'+row.mcr_item_code+'/'+row.token+'/detail'" class="dropdown-item ml-1" tag="button">
                                        <label class="text-primary" style="cursor: pointer;">
                                            {{row.mcr_number}}
                                        </label>
                                    </router-link>
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('old_material_number')" :prop="tt('old_material_number')" min-width="250px" sortable>
                                 <template slot="header" slot-scope="scope">
                                    <div class="row">
                                        <div class="col-12" style="text-align:center;">
                                            {{ tt('old_material_number') }}
                                        </div>
                                        <div class="col-12">
                                            <el-input size="mini" class="mb-2" v-model="params.old_material_number" @change="filter"></el-input>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot="{row}">
                                    <label @click="handleShowDetail(row)" class="text-primary" style="cursor: pointer;">
                                        {{row.old_material_number}}
                                    </label> 
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('material_number')" :prop="tt('material_number')" min-width="210px" sortable>
                                 <template slot="header" slot-scope="scope">
                                    <div class="row">
                                        <div class="col-12" style="text-align:center;">
                                            {{ tt('material_number') }}
                                        </div>
                                        <div class="col-12">
                                            <el-input size="mini" class="mb-2" v-model="params.material_number" @change="filter"></el-input>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot="{row}">
                                    <label @click="handleShowDetail(row)" class="text-primary" style="cursor: pointer;">
                                        {{row.material_number}}
                                    </label>
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('short_description')" :prop="tt('short_description')" min-width="250px" sortable>
                                <template slot="header" slot-scope="scope">
                                    <div class="row">
                                        <div class="col-12" style="text-align:center;">
                                            {{ tt('short_description') }}
                                        </div>
                                        <div class="col-12">
                                            <el-input size="mini" class="mb-2" v-model="params.description" @change="filter"></el-input>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot="{row}">
                                    {{row.short_description}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('UOM')" :prop="tt('UOM')" min-width="120px" sortable>
                                <template slot="header" slot-scope="scope">
                                    <div class="row">
                                        <div class="col-12" style="text-align:center;">
                                            {{ tt('UOM') }}
                                        </div>
                                        <div class="col-12">
                                            <el-input size="mini" class="mb-2" v-model="params.uom" @change="filter"></el-input>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot="{row}">
                                    {{ row?.stocks[0]?.meins }}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('type')" :prop="tt('type')" min-width="120px" sortable>
                                <template slot="header" slot-scope="scope">
                                    <div class="row">
                                        <div class="col-12" style="text-align:center;">
                                            {{ tt('type') }}
                                        </div>
                                        <div class="col-12">
                                            <el-input size="mini" class="mb-2" v-model="params.mtype_code" @change="filter"></el-input>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot="{row}">
                                    {{ row?.mtype_code }}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('unrestricted_used')" :prop="tt('unrestricted_used')" min-width="250px" sortable>
                                <template slot="header" slot-scope="scope">
                                    <div class="row">
                                        <div class="col-12" style="text-align:center;">
                                            {{ tt('unrestricted_used') }}
                                        </div>
                                        <div class="col-12">
                                            <el-input size="mini" class="mb-2" v-model="params.stock" @change="filter"></el-input>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot="{row}">
                                    <label @click="getFirstStock(row)">
                                        {{ getFirstStock(row) }}
                                    </label>
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('last_update')" :prop="tt('last_update')" min-width="230px" sortable>
                                <template slot="header" slot-scope="scope">
                                    <div class="row">
                                        <div class="col-12" style="text-align:center;">
                                            {{ tt('last_update') }}
                                        </div>
                                        <div class="col-12">
                                            <el-input type="date" size="mini" class="mb-2" v-model="params.created_at" @change="filter"></el-input>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot="{row}">
                                    {{ row.created_at}}
                                </template>
                            </el-table-column>
                        </el-table>
                        <skeleton-loading v-else/>
                    </div>  
                    <div class="card-footer pb-0 ">   
                        <span class="float-left">
                            <base-pagination :page-count="pagination.last_page" v-model="pagination.current_page" @click.native="handlePaginate(pagination.current_page)" size="sm"></base-pagination>
                        </span>                             
                        <span class="float-right">
                        {{ tt('page_info', {size: (pagination.current_page - 1) * pagination.per_page + table.length, total: pagination.total}) }}
                        </span>
                    </div>
                </div>
                <div class="card" v-else>
                    <div class="card-header">
                        <div class="row">
                            <div class="col text-center">
                                <h2 class="mb-0">
                                    <b>
                                       Live Search
                                    </b>
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-2">
                                <label class="mt-2">MCR Number</label>
                            </div>
                            <div class="col-6 mb-4">
                                <el-input
                                    type="text"
                                    v-model="params.mcr_number"
                                    :placeholder="tt('mcr_number')"
                                    size="large"
                                    @keyup.enter.native="searchMaterial"
                                ></el-input>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-2">
                                <label class="mt-2">Plant</label>
                            </div>
                            <div class="col-6">
                                  <base-input>
                                        <el-select v-model="params.plant" :placeholder="tt('plant_example_2')" :loading="initLoading" filterable remote reserve-keyword clearable @keyup.enter.native="searchMaterial">
                                            <el-option v-for="pl in plant" :key="pl.code" :label="pl.code +' - '+ pl.name" :value="pl.code"></el-option>
                                        </el-select>
                                </base-input>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-2">
                                <label class="mt-2">Material Number</label>
                            </div>
                            <div class="col-4 mb-4">
                                <el-input
                                    type="text"
                                    v-model="params.material_number"
                                    :placeholder="tt('material_number')"
                                    size="large"
                                    @keyup.enter.native="searchMaterial"
                                ></el-input>
                            </div>
                            <div class="col-6"></div>
                            <div class="col-2">
                                <label class="mt-2">Old Material Number</label>
                            </div>
                            <div class="col-4 mb-4">
                                <el-input
                                    type="text"
                                    v-model="params.old_material_number"
                                    :placeholder="tt('old_material_number')"
                                    size="large"
                                    @keyup.enter.native="searchMaterial"
                                ></el-input>
                            </div>
                            <div class="col-6"></div>
                            <div class="col-2">
                                <label class="mt-2">Description</label>
                            </div>
                            <div class="col-6 mb-4">
                                <el-input
                                    type="textarea"
                                    v-model="params.description"
                                    :placeholder="tt('description')"
                                    size="large"
                                    @keyup.enter.native="searchMaterial"
                                    resize="vertical"
                                ></el-input>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-2">
                                <label class="mt-2">PO Text</label>
                            </div>
                            <div class="col-6 mb-4">
                                <el-input
                                    type="textarea"
                                    v-model="params.po_text"
                                    :placeholder="tt('po_text')"
                                    size="large"
                                    @keyup.enter.native="searchMaterial"
                                    resize="vertical"
                                ></el-input>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-2">
                                <label class="mt-2">Stock</label>
                            </div>
                            <div class="col-6">
                                <el-radio-group v-model="params.stock_available" fill="#5e72e4">
                                    <el-radio-button :label="null">All</el-radio-button>
                                    <el-radio-button :label="true">Available</el-radio-button>
                                    <el-radio-button :label="false">Out of Stock</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-12">
                                <hr>
                                <base-button :loading="loading" type="sm" @click="searchMaterial" class="btn btn-block btn-lg btn-primary py-2">
                                    {{ tt('search') }}
                                </base-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <modal-detail :show-modal="detailModalShow" :source-data="selectedData" @close-modal="detailModalShow = false"></modal-detail>

        </div>
        <noaccess v-else/>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import tomatSearchService from '@/services/master/tomatSearch';
    import ModalDetail from '@/views/GeneralLayout/Components/TomatModalDetail.vue';
    import Swal from "sweetalert2";
    import baseApiUrl from '@/configs/config';

    export default {
        name: 'TomatSearch',
        components: {ModalDetail},
        data() {
            return {
                params: {
                    description: null,
                    plant:null,
                    material_number: null,
                    old_material_number: null,
                    po_text: null,
                    per_page: 25,
                    page: 1,
                    stock_available: null,
                    short_description: null,
                    uom: null,
                    mtype_code: null,
                    stock: null,
                    created_at: null,
                    mcr_number: null
                },
                table: [],
                pagination: {
                    current_page: 0,
                    last_page: 0,
                    per_page: 0,
                    total: 0,
                },
                endUserSearchMaterial: [],
                plant: [],
                links:[],
                listSelect:[],
                initLoading:false,
                loading: false,
                isSearched: false,
                detailModalShow: false,
                loadTable: false,
                loadDetailStock: false,
                selectedData: null,
                apiUrl: baseApiUrl.apiUrl,
                token: localStorage.token,
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
            rightDialogClass() {
                return this.detailModalShow.hasLeftData ? "modal-right" : "modal-center"
            }
        },
        mounted() {
            this.getPlants()
        },
        methods: {
            backToForm() {
                this.isSearched = false
                this.params.plant = null
                this.params.description = null
                this.params.material_number = null
                this.params.old_material_number = null
                this.params.po_text = null
                this.params.stock_available = null
                this.params.short_description = null,
                this.params.uom = null,
                this.params.mtype_code = null,
                this.params.stock = null,
                this.params.created_at = null
                this.params.mcr_number = null
                this.params.page = 1
            },
            getFirstStock(data)
            {
                const data_stock = data?.stocks?.find(stock => stock.werks == data.plant_code)

                return data_stock ? this.formatingTonnage(data_stock?.labst) : 0
            },
            formatingTonnage(tonnage)
            {
                const tonnage_splitted = tonnage.split('.');
                
                if (tonnage_splitted.length == 1) return tonnage

                const last_digit = tonnage_splitted[tonnage_splitted.length - 1]

                tonnage_splitted.pop()

                const formatting_tonnage = parseInt(tonnage_splitted.join(""), 10).toLocaleString("id-ID");

                return last_digit == 0 ? formatting_tonnage : `${formatting_tonnage},${last_digit}`
            },
            exportExcel() {
                const param_values = Object.values(this.params)
                const param_keys = Object.keys(this.params)
                const param = {}

                param_values.forEach((value, key) => {
                    if (value) param[param_keys[key]] = value
                })

                const payload = new URLSearchParams(param).toString();
                const url = `${this.apiUrl}tomat-search/export?${payload}&token=${this.token}`;
                window.open(url, '_blank');
            },
            handlePaginate(page) {
                this.params.page = page
                this.searchMaterial()
            },
            closeAll() {
                this.detailModalShow.left = false
                this.detailModalShow.right = false
            },
            handleShowDetail(data) {
                this.selectedData = data
                this.detailModalShow = true 
            },
            searchMaterial() {
                this.loading = true
                this.isSearched = true
                this.loadTable = true
                Api(this, tomatSearchService.index(this.params))
                    .onSuccess(response => {
                        this.table = response.data.data.data
                        this.pagination = {
                            current_page: response.data.data.current_page,
                            last_page: response.data.data.last_page,
                            per_page: response.data.data.per_page,
                            total: response.data.data.total,
                        }
                        this.loading = false
                        this.loadTable = false
                    }).onError(error => {
                        this.table = []
                        this.loadTable = false
                        this.loading = false
                    }).call();    
            },
            getPlants() {
                this.initLoading = true
                Api(this, tomatSearchService.getPlant())
                    .onSuccess(response => {
                        this.plant = response.data.data;    
                        this.initLoading = false;    
                    }).onError(error => {
                        this.plant = [];
                        this.initLoading = false;
                    }).call();          
            },
            chanePerPage() {
                this.searchMaterial()
            },
             filter() {
                this.searchMaterial()
            },
        },

    };
</script>
<style>
    .width {
        width: 95%; 
    }

    /* biar body tetap bisa scroll */
    body {
        overflow: auto !important;
    }

    /* modal kiri posisi */
    .modal-left {
        position: fixed !important;
        left: 2%;
        top: 10%;
        z-index: 2000 !important;
    }

    /* modal kanan posisi (mode dua modal) */
    .modal-right {
        position: fixed !important;
        right: 2%;
        top: 10%;
        z-index: 3000 !important;
    }

    /* modal kanan posisi (mode single) */
    .modal-center {
        position: fixed !important;
        left: 50% !important;
        top: 50% !important;
        transform: translate(-50%, -50%) !important;
        z-index: 2000 !important;
    }

    .modal-body-scroll {
        overflow-x: hidden;
        overflow-y: auto;
        min-height: 500px!important;
        max-height: 550px!important;
    }

</style>
